// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import SelMemberDialog from './SelMemberDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';




export default function DocPermissionEditDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate } = props;

  const rights = docDetail?.Rights || [];

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const vAll = (rights.length == 0) || rights[0].UserOrGroupID == "*";
  const [isAllFolderUsers, setIsAllFolderUsers] = useState(vAll);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }


  const initGridData = () => {
    const vData = rights.map(item => {
      return {
        "IsUser": item.IsUser,
        "DeptName": item.Dept,
        "UserOrGroupID": item.UserOrGroupID,
        "Name": item.Name,
        "Description": item.Desc,
      }
    });

    // console.log("initGridData vData", vData);
    setGridData(vData);

    setModified(false);
  }

  useEffect(() => {
    if (open === true) {
      initGridData();

      const xFunc = async () => {

        try {
          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, docDetail.FolderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);

        } catch (e) {
          onCatchPromiseError(e);
        }

      }
      xFunc();
    }



  }, [open]);

  const handleCloseClick = () => {
    // console.log("DocPermissionEditDialog close");
    // initGridData();
    onClose && onClose();
  }


  const handleAddByUser = async () => {

    setOpenAddUserDialog(true);

  };



  const [modified, setModified] = useState(false);

  const [selectedRecs, setSelectedRecs] = useState([]);
  const [gridData, setGridData] = useState([]);





  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }

  const handleSelectAddUsers = (aUsers, aGroups) => {
    console.log("aUsers", aUsers);
    console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = gridData.map(item => {
      return item
    });

    let vHasUpdate = false;

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "IsUser": true,
          "DeptName": addUser.Department,
          "UserOrGroupID": addUser.UserID,
          "Name": addUser.FullName,
          "Description": "",
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "IsUser": false,
          "DeptName": "",
          "UserOrGroupID": addGroup.GroupID,
          "Name": addGroup.Name,
          "Description": addGroup.Desc,
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    // console.log("vData", vData);
    setGridData(vData);

    if (vHasUpdate) {
      setModified(true);
    }

  }

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = gridData.filter(d => !selectedRecs.some(r => r.UserOrGroupID === d.UserOrGroupID));
    setGridData(vData);
    setSelectedRecs([]);

    setModified(true);
  }

  const handleRangeChange = (event) => {
    setIsAllFolderUsers(event.target.value === "0")
    setModified(true);
  }

  const handleSaveClick = () => {
    // console.log("handleSaveClick", gridData);

    let vUserList = [];

    if (isAllFolderUsers === true) {
      vUserList = ['*'];
    } else {
      vUserList = gridData.map(d => {
        return d.UserOrGroupID
      })

    }


    setShowLoading(true);
    DmsService.updateDocPermissionPromise(gState.sessionID, sysID, docDetail.DocID, vUserList)
      .then(() => {
        setShowLoading(false);

        setModified(false);

        afterUpdate && afterUpdate();
      })
      .catch((e) => {
        setShowLoading(false);

        console.log('Fail: ', e);

        setErrMsg(e.errMsg || e.message);
        setShowError(true);

      })


  }



  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.DeptName, nodeB.data.DeptName)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }

  const columnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    {
      field: 'Name', headerName: "Group/User Name", cellStyle: cellStyle, minWidth: 150, flex: "1",
      headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorName
    },
    { field: 'DeptName', headerName: "Department", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDept, },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDesc, },
  ], []);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="doc-permission-edit-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <SelMemberDialog
        open={openAddUserDialog}
        onClose={() => { setOpenAddUserDialog(false) }}
        members={allFolderUsers}
        groups={groups}
        onSelect={handleSelectAddUsers}
      />

      <DialogTitle id="alert-dialog-title">
        Permissions
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >

          <Box sx={{ py: 1, px: 1 }} >
            <FormControl component="fieldset">

              <RadioGroup
                aria-label="range"
                value={isAllFolderUsers ? "0" : "1"}
                onChange={handleRangeChange}
                name="radio-buttons-group-range"
              >
                <FormControlLabel value="0" control={<Radio />} label="Everyone who can access the folder" />
                <FormControlLabel value="1" control={<Radio />} label="Limited groups/users" />
              </RadioGroup>


            </FormControl>

          </Box>

          <Box sx={{ py: 1, px: 1, display: isAllFolderUsers ? "none" : "block" }} >
            <Button
              id="add-button"
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleAddByUser}
            >
              Add
            </Button>

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove}>
              Remove
            </Button>

          </Box>


          <div className="ag-theme-material" style={{ display: isAllFolderUsers ? "none" : "block", width: '100%', height: '100%', bgcolor: 'yellow' }}>
            <AgGridReact

              rowData={gridData}



              defaultColDef={{
                width: 100,
                resizable: true,
                sortable: true,
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              headerHeight={40}

              suppressNoRowsOverlay

              rowSelection="multiple"
              rowMultiSelectWithClick
              onSelectionChanged={onSelectionChanged}

            >


            </AgGridReact>

          </div>




        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button disabled={!modified} variant="contained" startIcon={<SaveIcon />} onClick={handleSaveClick} >
          Save
        </Button>
      </DialogActions>
    </Dialog>

  );
}

DocPermissionEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
